import React from 'react'
import PropTypes from 'prop-types'
import { localsMessages } from '../utility/getTemplateData'

const STYLES = {
	payPalStyles: {
		fontFamily: 'pp-sans-big-regular',
	},
	wrapper: {
		marginTop: 30,
		marginBottom: 22,
	},
	havePPLabel: {
		marginRight: 5,
		fontSize: 15,
		fontFamily: 'pp-sans-small-regular',
	},
	logInBtn: {
		fontSize: 13,
		paddingTop: 5,
		marginBottom: 0,
	}
}

class PayPalLogIn extends React.Component {
	constructor() {
		super();
	}

	render () {
		const guestMessages = localsMessages('common/pPLogIn') || {}
		const havePPLabel = guestMessages.label && guestMessages.label.havePP || ''
		const logInLabel = guestMessages.label && guestMessages.label.logIn || ''

		return (
			<div className="row text-center" style={STYLES.wrapper}>
				<span style={STYLES.havePPLabel}>{havePPLabel}</span>
				<a id="payWithPP"
					style={STYLES.logInBtn}
					className="vx_btn vx_btn-primary vx_btn-small"
					onClick={this.props.handleLogIn}>{logInLabel}</a>
			</div>
		);
	}
}

PayPalLogIn.propTypes = {
	label: PropTypes.string,
	handleLogIn: PropTypes.func
};

export default PayPalLogIn



// WEBPACK FOOTER //
// ./components/guestPPLogIn.js